import type { router as Router } from '../routes';
import { useUi } from '../store/ui';

/** Text or a link shared from another app becomes a prefilled quick-add: first line is the title. */
export async function installShareTarget(router: typeof Router): Promise<void> {
  const { CapacitorShareTarget } = await import('@capgo/capacitor-share-target');
  await CapacitorShareTarget.addListener('shareReceived', (event) => {
    const text = [event.title, ...(event.texts ?? [])]
      .filter((s): s is string => typeof s === 'string' && s.trim().length > 0)
      .join('\n')
      .trim();
    if (!text) return;
    const [first = '', ...rest] = text.split('\n');
    useUi.getState().openQuickAdd({ title: first.trim().slice(0, 120), notes: rest.join('\n').trim() || undefined, inbox: true });
    void router.navigate('/');
  });
}
